import { type IAchievementLevel } from "@framework/types";
import { cleanUpAsset } from "@framework/exchange";

export const achievementsLevelsCreateFilter = ({
  title,
  description,
  reward,
  amount,
  achievementLevel,
  achievementRuleId,
}: IAchievementLevel) => ({
  title,
  description,
  amount,
  reward: cleanUpAsset(reward) as any,
  achievementRuleId,
  achievementLevel,
});

export const achievementsLevelsEditFilter = ({
  title,
  description,
  reward,
  amount,
  achievementLevel,
  achievementRule,
}: IAchievementLevel) => ({
  title,
  description,
  reward: cleanUpAsset(reward) as any,
  amount,
  achievementRule,
  achievementLevel,
});

export const prepareAchievementsLevelsInitialValues = ({
  id,
  title,
  description,
  reward,
  amount,
  parameters,
  achievementRuleId,
  achievementLevel,
}: Partial<IAchievementLevel>) => {
  return {
    id,
    title,
    description,
    reward,
    amount,
    achievementRuleId,
    parameters: JSON.stringify(parameters),
    achievementLevel,
  };
};
